<!-- An inline version of the ConfirmIdentityForm -->
<template>
	<div class="bg-primary-100 rounded-lg px-6 py-4 shadow-lg">
		<RestartEncryptionModal
			:plan="plan"
			v-model="resetModalOpen"
		/>
		<form @submit.prevent="submitForm(plan)">
			<div
				class="grid w-full grid-cols-[minmax(0,1fr)_230px_32px] grid-rows-1 items-center justify-between gap-4"
			>
				<div class="text-sm">
					<p class="text-secondary-900 font-sans leading-tight">
						<span class="font-bold"
							>{{
								t('encryption.confirmIdentity.heading', {
									firstName: plan.firstName,
									lastName: plan.lastName,
								})
							}}:
						</span>
						{{ t('encryption.confirmIdentity.body') }}
					</p>
					<i18n-t
						keypath="encryption.confirmIdentity.restart"
						tag="p"
						class="text-slate-500 italic"
					>
						<button
							type="button"
							@click="resetModalOpen = true"
							class="font-bold text-red-500 italic underline"
						>
							{{ t('encryption.confirmIdentity.restartButton') }}
						</button>
					</i18n-t>
				</div>
				<div class="align-items-start flex flex-col justify-between">
					<input
						type="text"
						class="w-full rounded-lg border px-4 py-3"
						:class="[errorMessage && 'border-red-300 text-red-950']"
						:placeholder="t('encryption.confirmIdentity.inputPlaceholder')"
						v-model="secretValue"
						maxlength="11"
					/>
					<div
						v-if="errorMessage"
						class="mt-2 text-sm font-medium text-red-500"
					>
						{{ errorMessage }}
					</div>
				</div>
				<button
					type="submit"
					class="flex-none cursor-pointer"
					:disabled="!formValid || inProgress"
				>
					<ArrowRightCircleIcon
						class="size-9 rounded-full"
						:class="[
							formValid && !inProgress
								? 'text-accent-500'
								: 'text-secondary-400',
						]"
					/>
				</button>
			</div>
		</form>
	</div>
</template>

<script lang="ts" setup>
import RestartEncryptionModal from './RestartEncryptionModal.vue'
import type Plan from '@/classes/Plan'
import { usePresentationLocale } from '@/i18n'
import { useConfirmIdentity } from '@/mixins/confirmIdentity'
import { ArrowRightCircleIcon } from '@heroicons/vue/24/solid'
import { type PropType, ref } from 'vue'

const { t } = usePresentationLocale()

const props = defineProps({
	plan: {
		type: Object as PropType<Plan>,
		required: true,
	},
})

const { errorMessage, secretValue, formValid, inProgress, submitForm } =
	useConfirmIdentity()

const resetModalOpen = ref(false)
</script>
